import React, { useState } from "react";
import { peopleAPI } from "api/Community/PeopleAPI";
import { RectangularTextButton } from "components/Base/Buttons";

interface DiscipleshipRemovePeopleButtonProps {
  selectedItems: any[];
  onRemoved?: () => void;
  disabled?: boolean;
}

export default function DiscipleshipRemovePeopleButton({
  selectedItems,
  onRemoved,
  disabled = false,
}: DiscipleshipRemovePeopleButtonProps) {
  const [removing, setRemoving] = useState(false);

  const onRemove = async () => {
    console.log("DISCIPLESHIP REMOVE DEBUG");
    console.log("selectedItems:", selectedItems);

    if (selectedItems.length === 0) return;

    setRemoving(true);

    try {
      const results = await Promise.allSettled(
        selectedItems.map((person) =>
          peopleAPI.updateField(
            Number(person.id),
            "discipleship_stage_id",
            null
          )
        )
      );

      const rejected = results.filter((r) => r.status === "rejected");
      if (rejected.length > 0) {
        console.error("Some remove requests failed:", rejected);
      }

      await onRemoved?.();
    } catch (error) {
      console.error("Failed to remove people from discipleship stage:", error);
    } finally {
      setRemoving(false);
    }
  };

  return (
    <RectangularTextButton
      onClick={onRemove}
      disabled={disabled || removing || selectedItems.length === 0}
    >
      Remove People
    </RectangularTextButton>
  );
}